import React from 'react'

const ComercialMercadoContainer = () => (
  <>
    <iframe
      title="Fill Rate"
      width="100%"
      height="90%"
      src="https://app.powerbi.com/reportEmbed?reportId=f6dc4395-fd65-4e0d-ab17-6e804c3c043d&autoAuth=true&ctid=1a8e863a-6a66-4905-990b-f7062b267787"
      frameBorder="0"
      allowFullScreen="true"
    />
  </>
)

export default ComercialMercadoContainer
